import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Home from "./routes/Home";
import Timezone from "./routes/Timezone";
import Stickers from "./routes/Stickers";
import ComicStrip from "./routes/ComicStrip";
import "./index.css";

export default () => (
  <Switch>
    <Route exact path="/" component={Home} />
    <Route exact path="/tz" component={Timezone} />
    <Route exact path="/timezone" component={Timezone} />
    <Route exact path="/stickers" component={Stickers} />
    <Route exact path="/comic" component={ComicStrip} />
    <Redirect to="/" />
  </Switch>
);



// WEBPACK FOOTER //
// ./src/App.js